module.exports = __WEBPACK_EXTERNAL_MODULE_8__;


//////////////////
// WEBPACK FOOTER
// external "react-dom"
// module id = 8
// module chunks = 0 1